import { NavLink } from "react-router-dom"
import HasPermission, { CanManageCompany } from "app/PermissionChecker"

function CompanyNav() {

    const canManageCompany = HasPermission(CanManageCompany)

    return (
        <div className="col mb-2 text-end">
            <div className="btn-group ">
                <NavLink to="/dashboard/company" className={"btn btn-primary"}><i className="fa-solid fa-eye"></i> Dashboard</NavLink>

                {
                    canManageCompany &&
                    <>
                        <a href="" className="btn btn-success disabled"><i className="fa-solid fa-bolt"></i> Manage</a>
                        <NavLink to="/dashboard/company/edit" className={"btn btn-dark"}><i className="fa-solid fa-gear"></i> Settings</NavLink>
                    </>
                }

            </div>
        </div>
    )
}

export default CompanyNav